import mapFunction from './mapResources';

export default mapFunction('building_running_performances', {
    isFetching: false,
    items: []
});